import { Dispatch, SetStateAction, useState } from "react"
import { EvidenceStateValue, UploadEvidencesDrawe } from "../types"
import { sharedAws } from "../../../service/bucketS3/Storage"

export const useUploadEvidence = (): UploadEvidenceData => {
    const [showRequireds, setShowRequireds] = useState(false)
    const [evidenceCopy, setEvidenceCopy] = useState<{
        [k: string]: Record<string, {
            progress?: boolean;
            progressAmount?: string;
            upload?: boolean;
            name: string;
            url: string | File;
            ref?: any;
        }> | undefined;
    }>()
    const [deletedsEvidencesList, setDeletedsEvidencesList] = useState<string[]>([])
    const [evidencesRequiredAreLoad, setEvidencesRequiredAreLoad] = useState<Record<string, boolean>>({})
    const [evidencesDrawer, setEvidencesDrawer] = useState<UploadEvidencesDrawe>({
        open: false,
        type: {
            equivalence: [],
            accept: '',
        },
    })
    const someEvidenceIsRequired = () => !!Object.values(evidencesRequiredAreLoad ?? {}).some(evidence => !evidence)
    const deleteListOfFiles = async () => {
        if (!!deletedsEvidencesList?.length) {
            const response = await sharedAws.deleteList({ list: deletedsEvidencesList })
            if (typeof response == 'boolean') { setDeletedsEvidencesList([]) }
        }
    }


    function hasAnyValueChanged() {
        for (const [key, entry] of Object.entries(evidencesDrawer.value ?? {})) {
            const currentValue = entry.value;
            const initialValue = evidenceCopy?.[key];

            // Comparar usando JSON.stringify (o deepEqual si prefieres)
            if (JSON.stringify(currentValue) !== JSON.stringify(initialValue)) {
                return true; // Cambió al menos un `value`
            }
        }
        return false; // Ningún `value` cambió
    }
    const createCopy = ({ evidencesConfig = {} }: { evidencesConfig?: EvidenceStateValue }) => {
        const initialValuesCopy = Object.fromEntries(
            Object.entries(evidencesConfig).map(([key, entry]) => [key, entry.value])
        );
        setEvidenceCopy(initialValuesCopy)
    }

    const defaultEvidence = ({ evidencesConfig, requireList }: { evidencesConfig?: EvidenceStateValue; requireList?: Record<string, boolean> }) => {
        let requiredList = { ...requireList }
        Object.keys(requireList ?? {}).forEach((type) => {
            requiredList[type] = !!(Object.values(evidencesConfig?.[type]?.value ?? {})?.length)
        })
        createCopy({ evidencesConfig })
        setEvidencesRequiredAreLoad(requiredList)
        setEvidencesDrawer((prev) => ({
            ...prev,
            value: evidencesConfig,
        }))
    }
    return {
        showRequireds,
        evidencesDrawer,
        deletedsEvidencesList,
        evidencesRequiredAreLoad,
        defaultEvidence,
        setShowRequireds,
        deleteListOfFiles,
        hasAnyValueChanged,
        setEvidencesDrawer,
        someEvidenceIsRequired,
        setDeletedsEvidencesList,
        setEvidencesRequiredAreLoad,
    }
}

export type UploadEvidenceData = {
    evidencesDrawer: UploadEvidencesDrawe;
    deletedsEvidencesList: string[];
    showRequireds: boolean
    evidencesRequiredAreLoad: Record<string, boolean>;
    deleteListOfFiles: () => Promise<void>
    setShowRequireds: Dispatch<SetStateAction<boolean>>
    someEvidenceIsRequired: () => boolean
    hasAnyValueChanged(): boolean
    defaultEvidence: ({ evidencesConfig, requireList }: {
        evidencesConfig?: EvidenceStateValue;
        requireList?: Record<string, boolean>;
    }) => void
    setEvidencesDrawer: Dispatch<SetStateAction<UploadEvidencesDrawe>>
    setDeletedsEvidencesList: Dispatch<SetStateAction<string[]>>
    setEvidencesRequiredAreLoad: Dispatch<SetStateAction<Record<string, boolean>>>
}